import React from "react";
import { Button, Grid } from "@mui/material";
// import FileUploadIcon from "@mui/icons-material/FileUpload";

import {
  makePostRequest,
  makeGetRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";
import * as Yup from "yup";
import { Formik, Form } from "formik";
// import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import dummyPic from "../../../assets/Images/avtarPic.png";

//Validations For Resident Details
const Validation_Schema = Yup.object().shape({
  firstname: Yup.string()
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers not allowed!!"
    ),
  lastname: Yup.string()
    .required("Required")
    .matches(
      /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
      "Numbers not allowed!!"
    ),
  contact: Yup.string()
    .matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "Phone number is not valid"
    )
    .min(10, "phone no must be greater than or equal to 10 digits")
    .max(15, "phone no must be greater than or equal to 10-15 digits")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  age: Yup.number()
    .required("Required")
    .min(1, "Age Must Be At Least 1 Year")
    .max(99, "Please Enter Valid Age"),
  // societyName: Yup.string().required("Required"),
});

function AddSocietyAdmin() {
  // const navigate = useNavigate();

  const [profile_pic, setProfilePic] = React.useState("");
  const [firstname, setfirstname] = React.useState("");
  const [lastname, setlastname] = React.useState("");
  const [contact, setcontact] = React.useState("");
  const [email, setemail] = React.useState("");
  // const [password, setPassword] = React.useState("");
  const [age, setage] = React.useState("");
  // const [societyName, setSocietyName] = React.useState("");
  const [societiesList, setSocietiesList] = React.useState([]);
  const [societyId, setSocietyId] = React.useState();
  const [schema, setSchema] = React.useState();
  const [societyCode, setSocietyCode] = React.useState();

  var formikInitials = {
    firstname: "",
    lastname: "",
    contact: "",
    email: "",
    age: "",
    societyName: "",
  };

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    return fileUrl;
  }

  function validateImageOrFile(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadProfilePic(e) {
    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      setProfilePic(profilePicUrl);
    } else swal("Please upload a file with image format only", "", "warning");
  }

  async function GetAllSocieties() {
    makeGetRequest("society/getall")
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          console.log(response.data.data);
          const data = response.data.data.rows;
          console.log(data);
          setSocietiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function addSocietyAdmin() {
    let newPass = firstname + "@1234";
    let inputdata = {
      society_id: societyId,
      user_obj: {
        first_name: firstname,
        last_name: lastname,
        age: age,
        contact_no: contact,
        email_id: email,
        profile_pic: profile_pic,
        profile_mode: "public",
      },
      user_type: "SocietyAdmin",
      password: newPass,
      emergency_contact: false,
      schema_name: schema,
      society_code: societyCode,
    };

    await makePostRequest("resident/insert/admin", inputdata)
      .then((response) => {
        console.log(response);
        if (response.data.data !== undefined) {
          swal("Success", "Society Admin added successfully", "success", {
            timer: 1000,
            buttons: false,
          });

          setfirstname("");
          setlastname("");
          setage("");
          setcontact("");
          setemail("");

          formikInitials = {
            firstname: "",
            lastname: "",
            contact: "",
            email: "",
            age: "",
            family_mem_cnt: "",
            flat_cnt: "",
          };

          window.location.reload();
        }
      })
      .catch((err) => {
        swal(" " + err, "Please use other details", "warning");
      });
  }

  async function handleChangeSocietyId(e) {
    console.log("Handle Society Change ", e.target.options.selectedIndex);
    setSocietyId(e.target.value);
    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    console.log(dataset);
    let schemaName = dataset.isd;
    setSchema(schemaName);
    setSocietyCode(dataset.code);
  }

  React.useEffect(() => {
    GetAllSocieties();
  }, []);

  return (
    <>
      <div id="successfullAdd">
        <Formik
          enableReinitialize
          initialValues={formikInitials}
          validationSchema={Validation_Schema}
          onSubmit={addSocietyAdmin}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldTouched,
            touched,
            isValid,
            handleSubmit,
          }) => (
            <Form>
              <Grid container spacing={3} className="addCommitee1">
                <Grid item xs={12} md={12}>
                  <div
                    className="uploadImDiv uploadImDivNew"
                    style={{ marginTop: 15 }}
                  >
                    <div className="uploadInpuNewUpIm">
                      <div className="uploadIm">
                        {/* for Dummy Pic */}
                        {/* <img src={dummyPic} /> */}
                        {/* * */}
                        {profile_pic?
                        <img src={profile_pic} />
                        :
                        <img src={dummyPic} /> }
                      </div>
                      <div className="uploadInpu">
                        <EditIcon />
                        <input
                          type="file"
                          id="profile_pic"
                          value={values.profile_pic}
                          onChange={(event) => uploadProfilePic(event)}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    First Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    value={values.firstname}
                    onChange={handleChange("firstname")}
                    onBlur={() => setFieldTouched("firstname")}
                    onChangeCapture={(e) => setfirstname(e.target.value)}
                  />
                  {errors.firstname && touched.firstname ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.firstname}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Last Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    value={values.lastname}
                    onChange={handleChange("lastname")}
                    onBlur={() => setFieldTouched("lastname")}
                    onChangeCapture={(e) => setlastname(e.target.value)}
                  />
                  {errors.lastname && touched.lastname ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.lastname}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Age <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    maxLength={2}
                    value={values.age}
                    onChange={handleChange("age")}
                    onBlur={() => setFieldTouched("age")}
                    onChangeCapture={(e) => setage(e.target.value)}
                  />
                  {errors.age && touched.age ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.age}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Contact No. <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    id="contact"
                    maxLength={10}
                    value={values.contact}
                    onChange={handleChange("contact")}
                    onBlur={(e) => setFieldTouched("contact")}
                    onChangeCapture={(e) => setcontact(e.target.value)}
                  />
                  {errors.contact && touched.contact ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.contact}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">
                    Email Id <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="modalInputStSelect"
                    id="email"
                    value={values.email}
                    onChange={handleChange("email")}
                    onBlur={(e) => setFieldTouched("email")}
                    // onBlur={(e) =>
                    //   getUserByEmailId(e.target.value, "Resident")
                    // }
                    onChangeCapture={(e) => setemail(e.target.value)}
                  />
                  {errors.email && touched.email ? (
                    <div style={{ color: "red" }} className="errorField">
                      {errors.email}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="tabsLabel">Select Society</label>
                  <select
                    className="modalInputStSelect"
                    value={societyId}
                    onChange={(e) => handleChangeSocietyId(e)}
                  >
                    <option value="" data-isd="">
                      Society Name
                    </option>
                    {societiesList.map((key) => (
                      <option
                        value={key.society_id}
                        data-isd={key.schema}
                        data-code={key.society_code}
                      >
                        {key.society_name}
                      </option>
                    ))}
                  </select>
                </Grid>

                {/* <div className="orDivider">
            <span>OR</span>
          </div> */}

                {/* <Grid item xs={12} md={6}>
                  <div className="cretaeGroupLink orTx">
                    <span>Or</span>
                    <label className="tabsLabel">Enter Society Name</label>
                    <input className="modalInputStSelect" 
                      value={values.societyName}
                      onChange={handleChange("societyName")}
                      onBlur={() => setFieldTouched("societyName")}
                      onChangeCapture={(e) => setSocietyName(e.target.value)}
                    />
                    {errors.societyName && touched.societyName ? (
                      <div
                        style={{ color: "red" }}
                        className="errorField"
                      >
                        {errors.societyName}
                      </div>
                    ) : null}
                  </div>
                </Grid> */}

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button type="submit" className="modalMainBt">
                      Add Society Admin
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Society added <br />
                successfully in database
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AddSocietyAdmin;
